import { Outlet } from '@tanstack/react-router';
import { DefaultErrorBoundary } from 'components/ErrorBoundary/DefaultErrorScreen';
import { ToastProvider } from 'libs/Notify';
import { Suspense, type FC } from 'react';
import { AuthContext } from 'utils/contexts/AuthProvider';
import { TRPCContext } from 'utils/contexts/TrpcContext';

// <HeadContent /> lives in the document shell (routes/__root.tsx).
// The MUI/styled-components theme lives inside the dashboard layout
// (routes/_dashboard.lazy.tsx) so no MUI code reaches the prerendered
// landing pages.
export const AppProviders: FC = () => (
  <AuthContext>
    <TRPCContext>
      <DefaultErrorBoundary>
        <Suspense>
          <ToastProvider />
          <Outlet />
        </Suspense>
      </DefaultErrorBoundary>
    </TRPCContext>
  </AuthContext>
);
